var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-dropdown',{class:_vm.$style.dropdown,attrs:{"aria-role":"list","position":"is-bottom-left"},scopedSlots:_vm._u([{key:"trigger",fn:function({ active }){return _c('div',{attrs:{"role":"button"}},[_vm._t("default",null,{"active":active})],2)}}],null,true)},_vm._l((_vm.items),function(item,i){return _c('b-dropdown-item',{key:item.id,attrs:{"aria-role":"listitem","has-link":""},nativeOn:{"mouseover":function($event){_vm.hoveredItemIndex = i},"mouseleave":function($event){_vm.hoveredItemIndex = -1}}},[_c('router-link',{class:[
        {
          [_vm.$style.isPublished]: _vm.isPublishedDoc(item),
          [_vm.$style.isDraft]: _vm.isDraftDoc(item),
          [_vm.$style.isArchived]: _vm.isArchivedDoc(item),
          ['is-active']: _vm.isActive(item.id)
        }
      ],attrs:{"to":{
        name: 'editor',
        params: {
          documentId: item.id,
          projectId: _vm.projectId
        }
      },"title":item.title}},[_c('ProjectEditorHeaderTabTag',{attrs:{"active":_vm.hoveredItemIndex === i,"status":_vm.getDocumentStatus(item)}},[_vm._v(" "+_vm._s(_vm.getDocTypeDisplayNameFromDoc(item))+" ")]),_vm._v(" "+_vm._s(item.title)+" ")],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }